import { useMutation } from "@tanstack/react-query";
import http from "../../utils/http-common";

export function useDeleteUser() {
  const deleteUser = async (userId: number) => {
    const response = await http.delete(`/user/${userId}`);
    return response.data;
  };

  return useMutation({
    mutationFn: deleteUser,
  });
}
